module.exports = __webpack_public_path__ + "static/media/unnamed.18933bc9.jpg";